import debounce from 'lodash/debounce';

import {service_request as serviceRequestApi} from '~/api/private';
import {SOURCES} from '~/types/sources';

const executeSearch = async ({
  value,
  request_id,
  damage_id,
  tecrmi_enabled,
  is_fleet_car,
  is_retail_car,
  setResults,
  setSearching,
}) => {
  if (value.length < 3) {
    setResults([]);
    return;
  }

  setSearching(true);
  const results =
    is_fleet_car || is_retail_car
      ? {
          [SOURCES.Make]: null,
          [SOURCES.SlaTasks]: [],
          [SOURCES.TecRMI]: [],
        }
      : {
          [SOURCES.Rob]: [],
          [SOURCES.TecRMI]: [],
        };

  if (is_fleet_car) {
    const {result} = await serviceRequestApi.search_works(request_id, value, {
      search_rob_codes: true,
      make_tasks: true,
    });

    if (result.length > 0) {
      results[SOURCES.Make] = result.map((result) => ({
        ...result,
        search_source: SOURCES.Make,
      }));
    }
  }

  if (is_fleet_car || is_retail_car) {
    const {result} = await serviceRequestApi.search_sla_tasks(
      request_id,
      value,
    );

    if (result.length > 0) {
      results[SOURCES.SlaTasks] = result.map((result) => ({
        ...result,
        search_source: SOURCES.SlaTasks,
      }));
    }
  } else {
    const {result} = await serviceRequestApi.search_rob_code(
      request_id ?? damage_id,
      value,
      {
        include_tasks: true,
      },
    );

    if (result.length > 0) {
      results[SOURCES.Rob] = result.map((result) => ({
        ...result,
        search_source: SOURCES.Rob,
      }));
    }
  }

  if (tecrmi_enabled) {
    const {result} = await serviceRequestApi.search_works(
      request_id ?? damage_id,
      value,
      {
        search_rob_codes: true,
      },
    );

    if (result.length > 0) {
      results[SOURCES.TecRMI] = result.map((result) => ({
        ...result,
        search_source: SOURCES.TecRMI,
      }));
    }
  }

  setResults(results);
  setSearching(false);
};

export const doSearch = debounce((...args) => {
  const [
    value,
    request_id,
    damage_id,
    tecrmi_enabled,
    is_fleet_car,
    is_retail_car,
    setResults,
    setSearching,
  ] = args;

  return executeSearch({
    value,
    request_id,
    damage_id,
    tecrmi_enabled,
    is_fleet_car,
    is_retail_car,
    setResults,
    setSearching,
  });
}, 500);
